'use es6';

import { Map as ImmutableMap, fromJS } from 'immutable';
import * as http from 'reporting-data/request/http';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import resolveProperties from '../lib/salesAnalytics/resolveProperties';
import { AGGREGATION_PROPS } from './constants';
import generateReferences from '../lib/salesAnalytics/generateReferences';
import { filterCleanData, getTableData } from './helpers';
import { isTable, isTimeSeries, isSearch, translateFilters, isSingleDimensionTimeSeries, getQuery } from '../lib/salesAnalytics/helpers';
import { getDrilldownFields } from '../lib/salesAnalytics/drilldownColumns';
const transformTableAggragation = ({
  report,
  response
}) => {
  const data = getTableData({
    report,
    response
  });
  return {
    report,
    response,
    datasets: ImmutableMap({
      primary: Dataset({
        data,
        paginationSize: response.get('total')
      })
    })
  };
};
const transformChartAggregation = ({
  report,
  response
}) => {
  // When it's single dimensional time series, breakdowns may have missing bucket.
  // Quotas (which includes amounts and counts for all dates) should be used as the primary dataset.
  const primaryData = isSingleDimensionTimeSeries(report) ? response.get('quotas') : response.get('breakdowns');
  const quotaData = response.get('quotas');
  const metricData = fromJS([{
    metrics_primary: response.get('metrics_primary'),
    metrics_secondary: response.get('metrics_secondary')
  }]);
  return {
    report,
    response,
    datasets: ImmutableMap({
      primary: Dataset({
        data: primaryData
      }),
      quota: Dataset({
        data: quotaData
      }),
      summary: Dataset({
        data: metricData
      })
    })
  };
};
const transformAggregation = ({
  report,
  response
}) => isTable(report) ? transformTableAggragation({
  report,
  response
}) : transformChartAggregation({
  report,
  response
});
const transformSearch = ({
  report,
  response
}) => {
  const data = response.get('results').map(object => object.get('properties').map(property => property.get('value')).set('objectId', object.get('objectId')));
  return {
    report,
    response,
    datasets: ImmutableMap({
      primary: Dataset({
        data,
        paginationSize: response.get('total')
      })
    })
  };
};
const resolveData = report => {
  const config = report.get('config');
  if (isSearch(report)) {
    return http.post(`sales-reporting/attainment/objects`, {
      query: getQuery(report),
      data: {
        config: config.delete('offset'),
        offset: config.get('offset')
      }
    }).then(response => ({
      report,
      response
    }));
  }
  return http.post(`sales-reporting/attainment/${isTimeSeries(report) ? 'time-series' : 'total'}`, {
    query: getQuery(report),
    data: config
  }).then(response => ({
    report,
    response
  }));
};
export const resolveReport = report => {
  if (isSearch(report)) {
    return translateFilters(report).then(resolveData).then(transformSearch).then(resolveProperties(getDrilldownFields(report))).then(generateReferences).then(({
      datasets
    }) => datasets.map(dataset => ImmutableMap({
      data: dataset
    })));
  }
  return translateFilters(report).then(resolveData).then(filterCleanData).then(transformAggregation).then(resolveProperties(AGGREGATION_PROPS)).then(generateReferences).then(({
    datasets
  }) => datasets.map(dataset => ImmutableMap({
    data: dataset
  })));
};